import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import CampaignManagement from './CampaignManagement';

const CampaignsPanel = () => {
  return <CampaignManagement />;
};

export default CampaignsPanel;